import { lightningChart } from "@arction/lcjs";

const LC_KEY = process.env["VUE_APP_LC_KEY"];

export const LightningChart = {
  initialize: function () {
    return lightningChart({
      license: LC_KEY,
    });
  },
};
